import React from 'react';
import { IconContainer } from './IconContainer';

const LicensesIcon = (props) => {
    return (
        <IconContainer ariaLabel="licenses" cursor="pointer" { ...props }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
                <path d="M20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 4H5V20H19V4H14V13L10.5 11L7 13V4Z" />
            </svg>
        </IconContainer>
    )
}

export { LicensesIcon };